export function toLookups(data: any) {
  const personTypes: Record<string, string> = {
    INDIVIDUAL: 'Individual',
    COMPANY: 'Company'
  };

  const bpTypes: Record<string, string> = {
    AGENCY: 'Agency',
    BRANCH: 'Branch',
    BROKER: 'Broker',
    BROKER_POS: 'Broker POS',
    DELEGATE: 'Delegate',
    EMPLOYEE: 'Employee',
    HEADQUARTER: 'Headquarter',
    SALES_REPRESENTATIVE: 'Sales Representative'
  };
  const businessPartnerTypes: Record<string, string> = {};
  data?.BusinessPartnerType?.enumValues?.forEach((el: any) => {
    businessPartnerTypes[el.name] = el.name
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^\w/, (c: any) => c.toUpperCase());
  });

  const addressTypes: Record<string, string> = {
    WORK: 'Work',
    HOME: 'Home'
  };

  const personTitles: Record<string, string> = {};
  data?.core?.getTitles?.forEach((el: any) => {
    personTitles[el.id] = el.title;
  });

  const relatedCompanies: Record<string, string> = {};
  data?.salesforce?.getRelatedCompanies?.forEach((el: any) => {
    relatedCompanies[el.id] = el.title;
  });

  const activePersons: Record<string, string> = {};
  data?.salesforce?.getActivePersonsWithoutBusinessPartners?.forEach(
    (el: any) => {
      activePersons[el.id] = el.fullName;
    }
  );

  const countries: Record<string, string> = {};
  data?.core?.getCountries?.forEach((el: any) => {
    countries[el.id] = el.title;
  });

  const zones: Record<string, string> = {};
  data?.core?.getZones?.forEach((el: any) => {
    zones[el.id] = el.title;
  });

  const currencies: Record<string, string> = {};
  data?.core?.getCurrencies?.forEach((el: any) => {
    currencies[el.id] = el.title;
  });

  return {
    personTypes,
    bpTypes,
    businessPartnerTypes,
    addressTypes,
    personTitles,
    relatedCompanies,
    activePersons,
    countries,
    zones,
    currencies
  };
}
